import React, { useState, useEffect } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { publicAPI } from '../../services/api';
import SectionHeader from '../common/SectionHeader';
import LoadingSpinner from '../common/LoadingSpinner';
import './SkillsSection.css';

const SkillsSection = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('All');
  const [ref, isVisible] = useScrollAnimation();

  useEffect(() => {
    publicAPI.getSkills()
      .then(res => { if (res.success) setSkills(res.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const categories = ['All', ...new Set(skills.map(s => s.category))];
  const filtered = activeCategory === 'All' ? skills : skills.filter(s => s.category === activeCategory);

  return (
    <section className="section skills-section" ref={ref}>
      <div className="container">
        <SectionHeader title="Skills & Expertise" subtitle="Technologies and tools I work with" />
        {loading ? <LoadingSpinner /> : (
          <div className={`skills-content ${isVisible ? 'fade-in' : ''}`}>
            <div className="skill-tabs">
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`skill-tab ${activeCategory === cat ? 'active' : ''}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
            <div className="skills-grid">
              {filtered.map(skill => (
                <div key={skill.id} className="skill-card glass">
                  <div className="skill-header">
                    {skill.iconClass && <i className={skill.iconClass}></i>}
                    <h4>{skill.name}</h4>
                    <span className="skill-percent">{skill.proficiency}%</span>
                  </div>
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: isVisible ? `${skill.proficiency}%` : '0%' }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SkillsSection;
